import { render, staticRenderFns } from "./CefrScoreEditorDetailed.vue?vue&type=template&id=2683e60e&scoped=true&"
import script from "./CefrScoreEditorDetailed.vue?vue&type=script&lang=js&"
export * from "./CefrScoreEditorDetailed.vue?vue&type=script&lang=js&"
import style0 from "./CefrScoreEditorDetailed.vue?vue&type=style&index=0&id=2683e60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683e60e",
  null
  
)

export default component.exports